module.exports = __webpack_public_path__ + "static/media/slider-l4-768.dc037134.webp";